"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = exports.meetgreet = void 0;
const toccata_1 = require("@musicaudienceexchange/toccata");
const class_validator_1 = require("class-validator");
const app_1 = require("../app");
const meetgreet_1 = require("../firestore/meetgreet");
let ValidatorUserIdentifier = class ValidatorUserIdentifier {
    validate(obj) {
        return typeof obj.uid === 'string' || typeof obj.email === 'string';
    }
};
ValidatorUserIdentifier = __decorate([
    (0, class_validator_1.ValidatorConstraint)({ name: 'UserIdentifier', async: false })
], ValidatorUserIdentifier);
// eslint-disable-next-line @typescript-eslint/no-namespace
var meetgreet;
(function (meetgreet) {
    class Customer extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsEmail()
    ], Customer.prototype, "email", void 0);
    __decorate([
        toccata_1.validator.IsString()
    ], Customer.prototype, "firstName", void 0);
    __decorate([
        toccata_1.validator.IsString()
    ], Customer.prototype, "lastName", void 0);
    meetgreet.Customer = Customer;
    class ReserveSlotOptions extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsString()
    ], ReserveSlotOptions.prototype, "sessionId", void 0);
    __decorate([
        toccata_1.validator.IsEmail()
    ], ReserveSlotOptions.prototype, "email", void 0);
    meetgreet.ReserveSlotOptions = ReserveSlotOptions;
    class ReserveSlotRequest extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsString()
    ], ReserveSlotRequest.prototype, "sessionId", void 0);
    __decorate([
        toccata_1.validator.IsEmail()
    ], ReserveSlotRequest.prototype, "email", void 0);
    meetgreet.ReserveSlotRequest = ReserveSlotRequest;
    class ReserveSlotResponse extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsString()
    ], ReserveSlotResponse.prototype, "id", void 0);
    __decorate([
        toccata_1.validator.IsString()
    ], ReserveSlotResponse.prototype, "sessionId", void 0);
    __decorate([
        toccata_1.validator.IsString()
    ], ReserveSlotResponse.prototype, "eventId", void 0);
    meetgreet.ReserveSlotResponse = ReserveSlotResponse;
    class ClearSlotsRequest extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsString()
    ], ClearSlotsRequest.prototype, "sessionId", void 0);
    meetgreet.ClearSlotsRequest = ClearSlotsRequest;
    class ClearSlotsResponse extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsBoolean()
    ], ClearSlotsResponse.prototype, "success", void 0);
    meetgreet.ClearSlotsResponse = ClearSlotsResponse;
    class RoomTokenRequest extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsString()
    ], RoomTokenRequest.prototype, "identity", void 0);
    __decorate([
        toccata_1.validator.IsString()
    ], RoomTokenRequest.prototype, "room", void 0);
    meetgreet.RoomTokenRequest = RoomTokenRequest;
    class RoomTokenResponse extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsString()
    ], RoomTokenResponse.prototype, "token", void 0);
    meetgreet.RoomTokenResponse = RoomTokenResponse;
    class EmailNotificationRequest extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsString()
    ], EmailNotificationRequest.prototype, "eventId", void 0);
    __decorate([
        toccata_1.validator.IsString()
    ], EmailNotificationRequest.prototype, "roomId", void 0);
    __decorate([
        toccata_1.validator.IsString()
    ], EmailNotificationRequest.prototype, "sessionId", void 0);
    meetgreet.EmailNotificationRequest = EmailNotificationRequest;
    class EmailNotificationResponse extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsString()
    ], EmailNotificationResponse.prototype, "id", void 0);
    meetgreet.EmailNotificationResponse = EmailNotificationResponse;
    class CreateEventRequest extends toccata_1.Model {
    }
    __decorate([
        (0, toccata_1.TransformValidateModel)(meetgreet_1.BaseEvent)
    ], CreateEventRequest.prototype, "event", void 0);
    meetgreet.CreateEventRequest = CreateEventRequest;
    class CreateEventResponse extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsString()
    ], CreateEventResponse.prototype, "id", void 0);
    meetgreet.CreateEventResponse = CreateEventResponse;
    // DEPRECATED: use AddUserToSessionRequest
    class CreateSessionRequestMember extends toccata_1.Model {
        constructor() {
            super(...arguments);
            this.isAdmin = false;
        }
    }
    __decorate([
        toccata_1.validator.IsString()
    ], CreateSessionRequestMember.prototype, "uid", void 0);
    __decorate([
        toccata_1.validator.IsEnum(meetgreet_1.RoleType)
    ], CreateSessionRequestMember.prototype, "role", void 0);
    __decorate([
        toccata_1.validator.IsBoolean(),
        toccata_1.validator.IsOptional()
    ], CreateSessionRequestMember.prototype, "isAdmin", void 0);
    meetgreet.CreateSessionRequestMember = CreateSessionRequestMember;
    class CreateSessionRequest extends toccata_1.Model {
        constructor() {
            super(...arguments);
            this.members = [];
        }
    }
    __decorate([
        toccata_1.validator.IsString()
    ], CreateSessionRequest.prototype, "eventId", void 0);
    __decorate([
        (0, toccata_1.TransformValidateDateTime)()
    ], CreateSessionRequest.prototype, "startDate", void 0);
    __decorate([
        toccata_1.validator.IsNumber()
    ], CreateSessionRequest.prototype, "slots", void 0);
    __decorate([
        (0, toccata_1.TransformValidateModel)(CreateSessionRequestMember, { each: true }),
        toccata_1.validator.IsOptional()
    ], CreateSessionRequest.prototype, "members", void 0);
    __decorate([
        toccata_1.validator.IsString(),
        toccata_1.validator.IsOptional()
    ], CreateSessionRequest.prototype, "name", void 0);
    meetgreet.CreateSessionRequest = CreateSessionRequest;
    class CreateSessionResponse extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsString()
    ], CreateSessionResponse.prototype, "id", void 0);
    meetgreet.CreateSessionResponse = CreateSessionResponse;
    class DeleteSessionRequest extends toccata_1.Model {
        constructor() {
            super(...arguments);
            this.sessionId = [];
        }
    }
    __decorate([
        toccata_1.validator.IsString({ each: true })
    ], DeleteSessionRequest.prototype, "sessionId", void 0);
    meetgreet.DeleteSessionRequest = DeleteSessionRequest;
    class GetTeamMembersRequest extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsString()
    ], GetTeamMembersRequest.prototype, "eventId", void 0);
    meetgreet.GetTeamMembersRequest = GetTeamMembersRequest;
    class TeamMember extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsString()
    ], TeamMember.prototype, "uid", void 0);
    __decorate([
        toccata_1.validator.IsString()
    ], TeamMember.prototype, "name", void 0);
    __decorate([
        toccata_1.validator.IsString()
    ], TeamMember.prototype, "email", void 0);
    __decorate([
        toccata_1.validator.IsString(),
        toccata_1.validator.IsOptional()
    ], TeamMember.prototype, "photo", void 0);
    meetgreet.TeamMember = TeamMember;
    class GetTeamMembersResponse extends toccata_1.Model {
        constructor() {
            super(...arguments);
            this.members = [];
        }
    }
    __decorate([
        (0, toccata_1.TransformValidateModel)(TeamMember, { each: true })
    ], GetTeamMembersResponse.prototype, "members", void 0);
    meetgreet.GetTeamMembersResponse = GetTeamMembersResponse;
    class GetOrCreateUserByEmailRequest extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsString()
    ], GetOrCreateUserByEmailRequest.prototype, "email", void 0);
    meetgreet.GetOrCreateUserByEmailRequest = GetOrCreateUserByEmailRequest;
    class GetOrCreateUserByEmailResponse extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsString()
    ], GetOrCreateUserByEmailResponse.prototype, "uid", void 0);
    meetgreet.GetOrCreateUserByEmailResponse = GetOrCreateUserByEmailResponse;
    meetgreet.SessionUserActions = ['add', 'update', 'delete'];
    class SessionUserRequest extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsString(),
        toccata_1.validator.IsIn(meetgreet.SessionUserActions)
    ], SessionUserRequest.prototype, "action", void 0);
    __decorate([
        toccata_1.validator.IsString(),
        toccata_1.validator.IsOptional()
    ], SessionUserRequest.prototype, "displayName", void 0);
    __decorate([
        toccata_1.validator.IsObject(),
        toccata_1.validator.Validate(ValidatorUserIdentifier)
    ], SessionUserRequest.prototype, "identifier", void 0);
    __decorate([
        toccata_1.validator.IsString(),
        toccata_1.validator.IsOptional()
    ], SessionUserRequest.prototype, "phoneNumber", void 0);
    __decorate([
        (0, toccata_1.TransformValidateModel)(meetgreet_1.Role)
    ], SessionUserRequest.prototype, "role", void 0);
    __decorate([
        toccata_1.validator.IsString()
    ], SessionUserRequest.prototype, "sessionId", void 0);
    meetgreet.SessionUserRequest = SessionUserRequest;
    class SessionUserResponse extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsString()
    ], SessionUserResponse.prototype, "uid", void 0);
    meetgreet.SessionUserResponse = SessionUserResponse;
    class CancelSessionRequest extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsString()
    ], CancelSessionRequest.prototype, "sessionId", void 0);
    meetgreet.CancelSessionRequest = CancelSessionRequest;
    class CancelSessionResponse extends toccata_1.Model {
        constructor() {
            super(...arguments);
            this.error = null;
        }
    }
    __decorate([
        toccata_1.validator.IsBoolean()
    ], CancelSessionResponse.prototype, "success", void 0);
    __decorate([
        toccata_1.validator.IsObject(),
        toccata_1.validator.IsOptional()
    ], CancelSessionResponse.prototype, "error", void 0);
    meetgreet.CancelSessionResponse = CancelSessionResponse;
})(meetgreet = exports.meetgreet || (exports.meetgreet = {}));
function init(firebaseApp) {
    const functions = firebaseApp
        ? firebaseApp.functions()
        : app_1.app.firebase.functions();
    return {
        reserveSlot: (0, toccata_1.createFunction)(functions, 'meetgreet-reserveSlot', meetgreet.ReserveSlotRequest, meetgreet.ReserveSlotResponse),
        resetSlots: (0, toccata_1.createFunction)(functions, 'meetgreet-resetSlots', meetgreet.ClearSlotsRequest, meetgreet.ClearSlotsResponse),
        token: (0, toccata_1.createFunction)(functions, 'meetgreet-token', meetgreet.RoomTokenRequest, meetgreet.RoomTokenResponse),
        emailNotification: (0, toccata_1.createFunction)(functions, 'meetgreet-emailNotification', meetgreet.EmailNotificationRequest, meetgreet.EmailNotificationResponse),
        createEvent: (0, toccata_1.createFunction)(functions, 'meetgreet-createEvent', meetgreet.CreateEventRequest, meetgreet.CreateEventResponse),
        createSession: (0, toccata_1.createFunction)(functions, 'meetgreet-createSession', meetgreet.CreateSessionRequest, meetgreet.CreateSessionResponse),
        deleteSession: (0, toccata_1.createFunction)(functions, 'meetgreet-deleteSession', meetgreet.DeleteSessionRequest, meetgreet.DeleteSessionRequest),
        getTeamMembers: (0, toccata_1.createFunction)(functions, 'meetgreet-getTeamMembers', meetgreet.GetTeamMembersRequest, meetgreet.GetTeamMembersResponse),
        getOrCreateUserByEmail: (0, toccata_1.createFunction)(functions, 'meetgreet-getOrCreateUserByEmail', meetgreet.GetOrCreateUserByEmailRequest, meetgreet.GetOrCreateUserByEmailResponse),
        sessionUser: (0, toccata_1.createFunction)(functions, 'meetgreet-sessionUser', meetgreet.SessionUserRequest, meetgreet.SessionUserResponse),
        cancelSession: (0, toccata_1.createFunction)(functions, 'meetgreet-cancelSession', meetgreet.CancelSessionRequest, meetgreet.CancelSessionResponse),
    };
}
exports.init = init;
//# sourceMappingURL=meetgreet.js.map